import React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-all duration-300 ease-in-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default:
          "bg-gradient-to-r from-orange-400 via-red-500 to-pink-500 text-white hover:scale-105 hover:from-orange-500 hover:to-pink-600 focus:ring-2 focus:ring-orange-500",
        destructive:
          "bg-red-600 text-white hover:bg-red-700 focus:ring-2 focus:ring-red-500",
        outline:
          "border-2 border-gray-300 bg-transparent text-gray-800 hover:bg-gray-100 focus:ring-2 focus:ring-blue-500",
        secondary:
          "bg-green-600 text-white hover:bg-green-700 focus:ring-2 focus:ring-green-500",
        ghost:
          "hover:bg-gray-200 hover:text-gray-800 text-gray-600 focus:ring-2 focus:ring-blue-500",
        link:
          "text-blue-600 underline-offset-4 hover:underline focus:ring-2 focus:ring-blue-500",
      },
      size: {
        default: "h-12 px-6 text-lg rounded-lg",
        sm: "h-9 px-4 text-sm rounded-md",
        lg: "h-12 px-10 text-xl rounded-xl",
        icon: "h-12 w-12 rounded-full",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

const Button = React.forwardRef(function Button(
  { className, variant, size, asChild = false, ...props },
  ref
) {
  const Component = asChild ? Slot : "button";
  return (
    <Component
      className={`${buttonVariants({ variant, size })} ${className}`}
      ref={ref}
      {...props}
    />
  );
});

Button.displayName = "Button";

export { Button, buttonVariants };
